import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { SeniorLayout } from './layout/SeniorLayout';
import AdminDashboard from '../pages/admin/AdminDashboard';
import { AdminLayout } from '../pages/admin/AdminLayout';

type ViewMode = 'admin' | 'senior';

export function HomeRouter() {
  const { role, roleLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (roleLoading || hasRedirected.current) return;
    
    // Only redirect from exact "/" path
    if (location.pathname !== '/') return;
    
    hasRedirected.current = true;
    
    if (role === 'admin' || role === 'superadmin') {
      navigate('/admin', { replace: true });
    } else if (!role) {
      navigate('/select-role', { replace: true });
    } else {
      navigate('/senior', { replace: true });
    }
  }, [roleLoading, role]);

  return null;
}
